/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".lyrics-modal-container{width:50%;height:95%;max-width:800px}.lyrics-modal-container .mat-dialog-container{background:#2a2a35;padding:0}@media only screen and (max-width:768px){.lyrics-modal-container{width:90%}}.modal lyrics-modal .mat-dialog-content{color:#c2c2ca;font-size:2rem;font-weight:300;text-align:center;width:100%;height:100%;max-height:none;background:inherit;padding:15px;margin:0}.modal lyrics-modal .close-button{color:#898b8c;position:absolute;top:5px;right:10px}"];
export { styles as styles };
